// extracted by mini-css-extract-plugin
module.exports =  {"currentPackage":"MAGgbbbjHg9s5xtEg2Hg"};